<template>
  <div id="app" v-cloak>
    <div v-if="pathname[this.pathname.length - 2] != 'user_tracking_detail'">

      <b-navbar toggleable="lg" type="light" variant="light">
        <b-navbar-brand href="#">
          <img :src="require('@/assets/logo/logo_' + $site + '.png')" width="180" />
        </b-navbar-brand>
        <b-navbar-brand :to="userclass == 'admin' ? '/report' : '/report_user'" style="color:#039e54">ระบบติดตามสถานะ
          (E-Tracking)</b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/dashboard" :class="[this.$route.name == 'dashboard' ? 'active' : '']">
               แดชบอร์ด
            </b-nav-item>
            <b-nav-item to="/report" :class="[this.$route.name == 'report' ? 'active' : '']"
              v-if="userclass == 'admin'">รายการทั้งหมด</b-nav-item>
            <b-nav-item to="/change_status" :class="[this.$route.name == 'change_status' ? 'active' : '']"
              v-if="userclass == 'admin'">เปลี่ยนสถานะ</b-nav-item>
            <b-nav-item to="/kbs" :class="[this.$route.name == 'kbs' ? 'active' : '']"
              v-if="userclass == 'admin'">E-KBS</b-nav-item>
            <!-- <b-nav-item to="/report_excel" :class="[this.$route.name == 'report_excel' ? 'active' : '']"
              v-if="userclass == 'admin'">รายงาน Workload</b-nav-item> -->
            <b-nav-item-dropdown text="รายงาน" right v-if="userclass == 'admin'">
              <b-dropdown-item to="/report_excel">Workload</b-dropdown-item>
              <b-dropdown-item to="/report_excel_datediff">ระยะเวลาการอนุญาต</b-dropdown-item>
              <b-dropdown-item to="/report_excel_datediff_process0">ใกล้ครบกำหนด (สถานะรับเรื่อง)</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item to="/report_user" :class="[this.$route.name == 'report_user' ? 'active' : '']"
              v-if="userclass == 'user'">ประวัติการทำรายการ</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown right v-if="user">
              <template #button-content>
                <span><i class="bi bi-person-circle"></i> ผู้ใช้งาน: {{ user ? user.name : "" }} </span>
              </template>
              <b-dropdown-item :href="this.$dga_domain + '/Account/Profile'" target="blank">Profile </b-dropdown-item>
              <div v-if="userclass == 'admin'">
                <b-dropdown-item to="/user">จัดการผู้ใช้งาน </b-dropdown-item>
              </div>
              <b-dropdown-item @click="Logout()">ออกจากระบบ </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item to="/auth" v-else>
              <template>
                <span><i class="bi bi-person-circle"></i> เข้าสู่ระบบ </span>
              </template>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <router-view />

  </div>
</template>

<script>
import axios from "axios";
import { mapState } from 'vuex'

export default {
  data() {
    return {
      userclass: null,
      interval: 0,
      pathname: window.location.pathname.split("/")
    };
  },
  computed: {
    ...mapState({
      user: store => store.user
    })
  },
  created() {
    if (this.pathname[this.pathname.length - 2] != 'user_tracking_detail' && this.pathname[this.pathname.length - 1] != 'authen') {
      this.checkin()
      setInterval(() => this.checkin(), 60000);
    }
  },
  methods: {
    checkin() {
      this.$store.dispatch('setUser').then(response => {
        console.log("OK Good!")
        this.getusername()
      }, error => {
        localStorage.clear()
        this.$router.push("/auth");
      })
    },
    getusername() {
      axios
        .post("/api/getuser.php", {
          accesstoken: this.user.ssj_token
        })
        .then((result) => {
          this.userclass = result.data.userclass
        });
    },

    Logout() {
      let personal_token = this.user.id_token
      let redirect_uri = this.$domainfront + "/logout"
      let dga_domain = this.$dga_domain
      document.location.href = dga_domain + "/connect/endsession?id_token_hint=" + personal_token + "&post_logout_redirect_uri=" + redirect_uri;


    },

  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit&display=swap");

#app {
  font-family: "Kanit", sans-serif !important;
  background-color: #046034;
}

[v-cloak] {
  display: none;
}

.bg-ssj {
  background-color: #046034;
}

html {
  background-color: #046034;
}

.container {
  background-color: #046034;
}

.navbar-light .navbar-nav .active>.nav-link {
  color: #5887bb !important;
}
</style>